module.exports = __webpack_public_path__ + "static/media/9_Puma golf - Okinawa.7bd6963d.jpg";